import axios from 'axios';

export default class Localization {
	constructor(mappings) {
		this.mappings = {};
		this.count = 0;
		
		if (mappings) {
			if (mappings.hasOwnProperty('localizations')) {
				this.mappings = mappings.localizations;
			}
			
			if (mappings.hasOwnProperty('localizations_size')) {
				this.count = parseInt(mappings['localizations_size']);
			}
		}
	}
	
	/**
	 * @method fetchMappings
	 * Fetch mappings from server
	 * @param  {string} template
	 * @return {promise}
	 */
	static fetchMappings (template) {
		return axios({
			method: 'POST',
			url: '/apps/localization',
			data: {template}
		});
	}
	
	/**
	 * @method substitute
	 * @param  {string} string
	 * String to replace
	 * @return {string}
	 * substituted string
	 */
	substitute (string) {
		if (this.count === 0){
			return string
		}
		
		let mapping = this.mappings[string];
		return mapping || string;
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/common/react/utilities/localization.js